export class GetMerchantRequestParams {
    pageNo: number = 1;
    rowPerPage: number = 10;
    filter: string = '';
    bankCode: string = '';
    roleId: string | null = null;
}

export class CreateMerchantParams {
  id: string = '';
  name: string = '';
  user: string = '';
  password: string = '';
  secret_code: string = '';
  callback_url: string = '';
  expired_date: string = '';
  payment_type: string = '';
  balance: number = 0;
  bank_account: string = '';
  bank_name: string = '';
  bank_branch: string = '';
  add_params1: string = '';
  add_params2: string = '';
}


export class UpdateMerchantRequestParams extends CreateMerchantParams {
  oldPassword?: string; 
}



export interface MerchantData {
  id: string;
  code: string;
  name: string;
  user: string;
  password: string;
  secret_code: string;
  callback_url: string;
  expired_date: string;
  payment_type: string;
  balance: number;
  bank_account: string;
  bank_name: string;
  bank_branch: string;
  add_params1: string;
  add_params2: string;
}


export interface GetMerchantResponse {
  code: number;
  message: string;
  data: MerchantData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetMerchantByIdResponse {
  code: number;
  message: string;
  data: MerchantData;
}

export interface DeleteMerchantByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
